import React, {Component, Fragment} from 'react'
import {Form, Input, Row, Col, Select, DatePicker, Button, Table, message} from 'antd';
import {baseUrl, reqTrackList, reqOrderIds} from '../../api'
import moment from 'moment';
import 'moment/locale/zh-cn';
import {
    ORDER_STATUS, LOGISTICS_STATUS, DELIVERY_TYPE, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR
} from '../../utills/constants'
import queryString from "query-string";
import {convertToOptions} from "../../components/options";
import {getIcons} from '../../utills/common'

moment.locale('zh-cn');
const {Option} = Select;

class OrderList extends Component {

    state = {
        total: 0, // 商品的总数量
        orderList: [], // 商品的数组
        pageNum: 1,
        searchData: {},
        deliveryFromDt: null,
        deliveryToDt: null,
        sortData: {},
        arrow: 'up-arrow',
        selectedRowKeys: [],
        selectedRows: [],
    }

    componentDidMount() {
        const orderList = JSON.parse(sessionStorage.getItem("orderList"));
        if (orderList) {
            this.setState({
                arrow: orderList.arrow,
                deliveryFromDt: orderList.deliveryFromDt,
                deliveryToDt: orderList.deliveryToDt
            }, () => {
                this.initFormValue(orderList);
                this.getProducts(1, this.state.sortData);
            })
        } else {
            this.getProducts(1, this.state.sortData);
        }
    }

    initFormValue = (orderList) => {
        const {setFieldsValue} = this.props.form;
        const deliveryFromDt = orderList.deliveryFromDt ? moment(orderList.deliveryFromDt, 'YYYY-MM-DD HH:mm:ss') : null;
        const deliveryToDt = orderList.deliveryToDt ? moment(orderList.deliveryToDt, 'YYYY-MM-DD HH:mm:ss') : null;
        const planDt = orderList.planDt ? moment(orderList.planDt, 'YYYY-MM-DD') : null;
        setFieldsValue({...orderList, deliveryFromDt, deliveryToDt, planDt});
    };
    getProducts = async (pageNum = 1, sortData = this.state.sortData, values = this.props.form.getFieldsValue()) => {
        const pageSize = 10;
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        });
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        if (sortData) {
            values.sort = sortData.sort;
            values.order = sortData.order;
        }
        this.setDateValues(values);
        this.reqTrackList(values);
        this.setState({selectedRowKeys: [], selectedRows: []})
    }
    //设置date类型的值
    setDateValues = (values) => {
        const {deliveryFromDt, deliveryToDt, departFromDt, departToDt} = this.state;
        values.deliveryFromDt = deliveryFromDt;
        values.deliveryToDt = deliveryToDt;
        values.departFromDt = departFromDt;
        values.departToDt = departToDt;
        values.planDt = values.planDt ? values.planDt.format('YYYY-MM-DD') : null;
        if (!values.orderStatus) {
            values.notInStatusStr = 'audit';
        }
    };
    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.getProducts(1, this.state.sortData, values);
                values.arrow = this.state.arrow;
                //  values.deliveryType = this.state.deliveryType;
                sessionStorage.setItem("orderList", JSON.stringify(values));
            }
        });
    };

    reqTrackList = async (po) => {
        const result = await reqTrackList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else {
            message.error(result.message);
        }
    };
    // 日期选择
    onDateChange = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryFromDt: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryToDt: dateString
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        const sortData = {
            sort: sorter.field,
            order: sorter.order,
        }
        this.setState({
            sortData
        })
        this.getProducts(pageNum, sortData)
    };
    moreClick = () => {
        const {arrow} = this.state;
        this.setState({
            arrow: arrow === 'down-arrow' ? 'up-arrow' : 'down-arrow'
        })
    };

    handleReset = () => {
        this.props.form.resetFields();
        this.setState({deliveryFromDt: null, deliveryToDt: null});
        sessionStorage.removeItem("orderList");
    }
    //下载装车照片、下载随车文件
    downloadZip = async (actionUrl, type) => {
        let url;
        const {selectedRowKeys} = this.state;
        //未选中数据，按照查询条件
        if (selectedRowKeys.length === 0) {
            const values = this.props.form.getFieldsValue();
            const {deliveryFromDt, deliveryToDt, departFromDt, departToDt} = this.state;
            values.deliveryFromDt = deliveryFromDt;
            values.deliveryToDt = deliveryToDt;
            values.departFromDt = departFromDt;
            values.departToDt = departToDt;
            values.planDt = values.planDt ? values.planDt.format('YYYY-MM-DD') : null;
            values.orderStatusList = Array.isArray(values.orderStatusList) ? values.orderStatusList.toString() : null;
            if (type === 'photo') {//装车照片是一个订单一个订单下载
                let result = await reqOrderIds(values);
                if (result.code === 200) {
                    for (let id of result.data) {
                        url = baseUrl + actionUrl + 'orderId=' + id;
                        window.open(url, "_blank");
                    }
                } else {
                    message.error(result.message)
                }
            } else {
                url = baseUrl + actionUrl + queryString.stringify(values);
                window.open(url, "_blank");
            }
        } else { //选中数据，按照orderIds
            if (type === 'photo') {//装车照片是一个订单一个订单下载
                for (let id of selectedRowKeys) {
                    url = baseUrl + actionUrl + 'orderId=' + id;
                    window.open(url, "_blank");
                }
            } else {
                url = baseUrl + actionUrl + 'ids=' + selectedRowKeys.toString();
                window.open(url, "_blank");
            }
        }
    };

    render() {
        const {orderList, total, deliveryType, selectedRowKeys} = this.state;
        const form = this.props.form;
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 9},
                sm: {span: 9},
            },
            wrapperCol: {
                xs: {span: 13},
                sm: {span: 13},
            },
        }
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({selectedRowKeys, selectedRows})
            },
        }
        const columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                width: 140,
                sorter: true,
                render: (text, record) => (
                    <a onClick={() => this.props.history.push('/orderInfoView', {orderId: record.id})}>{text}</a>
                )
            }, {
                title: '揽收单位',
                dataIndex: 'entName',
            }, {
                title: '运输类型',
                dataIndex: 'deliveryType',
                width: 100,
                render: (text) => {
                    return DELIVERY_TYPE[text]
                }
            }, {
                title: '起运地',
                sorter: true,
                dataIndex: 'originCity',
                render: (text, record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            }, {
                title: '出境口岸',
                dataIndex: 'customsPortName',
            }, {
                title: '转关地/清关地/目的机场',
                dataIndex: 'destinationStartCountry',
                width: 140,
                render: (text, record) => {
                    if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(record.deliveryType)) {
                        return <span>{record.customsClearanceCountry}&nbsp;{record.customsClearanceCity}</span>
                    }
                    if (DELIVERY_TYPE_AIR.hasOwnProperty(record.deliveryType)) {
                        return <span>{record.customsClearanceCountry}&nbsp;{record.customsClearanceCity}
                            /{record.destinationStartCountry}&nbsp;{record.destinationStartCity}</span>
                    }
                    return <span>{record.destinationStartCountry}&nbsp;{record.destinationStartCity}</span>
                }
            }, {
                title: '目的地',
                sorter: true,
                dataIndex: 'destinationCountry',
                width: 140,
                render: (text, record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            }, {
                title: '还箱地',
                sorter: true,
                dataIndex: 'boxReturnStation',
                width: 140,
            },
            {
                title: '集装箱号',
                dataIndex: 'boxNo',
                width: 110,
                render: (text, record) => (
                    <span>
                    {record.boxNo.map((c, i) => {
                            return <div key={i}>{c}</div>
                        }
                    )}
                  </span>
                )
            }, {
                title: '提箱文件',
                dataIndex: 'boxFileVehicle',
                width: 150,
                render: (text, record) => {
                    return getIcons(record, record.deliveryType)
                }
            }, {
                title: '订单状态',
                sorter: true,
                dataIndex: 'orderStatus',
                render: (text, record) => (
                    <span>
                        {ORDER_STATUS[text]}
                    </span>
                )
            }, {
                title: '物流状态',
                sorter: true,
                dataIndex: 'logisticsStatus',
                render: (text, record) => (
                    <span>
                        {LOGISTICS_STATUS[text]}
                    </span>
                )
            }, {
                title: '预计提货时间',
                sorter: true,
                dataIndex: 'deliveryEstimateDt',
            }, {
                title: '提货时间',
                sorter: true,
                dataIndex: 'deliveryTime',
            }, {
                title: '班次时间',
                sorter: true,
                dataIndex: 'planDt',
            }, {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 80,
                render: (text, record) => {
                    return <span>
                    {/*{record.logisticsStatus === 'cancelled'?null:<AuthLinkButton authority="order:edit"*/}
                    {/*                   onClick={() => this.props.history.push('/orderInfo/space', {orderId: record.id})}>编辑</AuthLinkButton>}*/}
                        <a onClick={() => this.props.history.push('/TrackDetail', {orderId: record.id})}>物流查询</a>
                        {/*<AuthLinkButton authority="order:download"
                         onClick={() => window.location.href = baseUrl + "/api/v1/p/file/fileCompressionDownload?orderId=" + record.id + "&orderNo=" + record.orderNo}>下载</AuthLinkButton>
                         */}                        </span>
                }
            }
        ];
        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>订单列表
                    <span className="arrow"
                          onClick={this.moreClick}>{this.state.arrow === 'down-arrow' ? '收起' : '更多'}<span
                        className={this.state.arrow}></span></span></div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={6}>
                            <Form.Item label="订单编号">
                                {getFieldDecorator('orderNo', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="集装箱号">
                                {getFieldDecorator('boxNo', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        {this.state.arrow === 'down-arrow' ?
                            <Fragment>
                                <Col span={6}>
                                    <Form.Item label="揽收单位">
                                        {getFieldDecorator('entName', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="起运地">
                                        {getFieldDecorator('departure', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="转关地/清关地/目的机场">
                                        {getFieldDecorator('transitPoint', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="目的地">
                                        {getFieldDecorator('destination', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="还箱地">
                                        {getFieldDecorator('boxReturnStation', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="订单状态">
                                        {getFieldDecorator('orderStatus', {
                                            initialValue: '',
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            {/* <Option value="audited">待订舱</Option>*/}
                                            <Option value="booked">已订舱</Option>
                                            <Option value="boxed">已装箱</Option>
                                            <Option value="declare">待报关</Option>
                                            <Option value="declaring">报关中</Option>
                                            <Option value="released">已放行</Option>
                                            <Option value="cancelled">已取消</Option>
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="物流状态">
                                        {getFieldDecorator('logisticsStatus', {
                                            initialValue: '',
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            <Option value="waiting">待提货</Option>
                                            <Option value="boxed">已装箱</Option>
                                            <Option value="transport">运输中</Option>
                                            <Option value="declaring">报关中</Option>
                                            <Option value="released">已放行</Option>
                                            <Option value="destination">已到达</Option>
                                            <Option value="cancelled">已取消</Option>
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="提货时间" className='time-input-to'>
                                        {getFieldDecorator('deliveryFromDt')(<DatePicker
                                            showTime format="YYYY-MM-DD HH:mm:ss"
                                            onChange={this.onDateChange} style={{width: "100%", minWidth: 10}}
                                        />)}

                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label={"至"} className='time-input-to'>
                                        {getFieldDecorator('deliveryToDt')(<DatePicker
                                            showTime format="YYYY-MM-DD HH:mm:ss"
                                            onChange={this.onDateChange2} style={{width: "100%", minWidth: 10}}
                                        />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="运输类型">
                                        {getFieldDecorator('deliveryType', {
                                            initialValue: '',
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            {convertToOptions(DELIVERY_TYPE)}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label={"班次时间"} className='time-input-to'>
                                        {getFieldDecorator('planDt')(
                                            <DatePicker showTime format="YYYY-MM-DD"
                                                        style={{width: "100%", minWidth: 10}}/>)}
                                    </Form.Item>
                                </Col>
                            </Fragment> : null}
                        <Col span={12} style={{float: 'right'}}>
                            <Button style={{float: 'right',}}
                                    onClick={() => this.downloadZip("/api/v1/p/file/vehicleFileBatch?")}>下载随车资料</Button>
                            <Button className='margin-btn' style={{float: 'right',}}
                                    onClick={() => this.downloadZip("/api/v1/p/file/orderDeliveryFileDownload?", 'photo')}>下载装车照片</Button>
                            <Button className='margin-btn' style={{float: 'right'}}
                                    onClick={this.handleReset}>清空</Button>
                            <Button className='margin-btn' type='primary' htmlType="submit"
                                    style={{float: 'right'}}>查询</Button>
                        </Col>
                    </Row>
                </Form>
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    bordered
                    dataSource={orderList}
                    rowKey='id'
                    scroll={{x: 1850}}
                    onChange={this.handleTableChange}
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true,
                    }}
                    size="middle"
                />
            </div>

        )
    }
}
const FreightListFrom = Form.create()(OrderList)
export default FreightListFrom